// Refer to graasp-query-client

export const STALE_TIME_MILLISECONDS = 0;
export const CACHE_TIME_MILLISECONDS = 1000 * 60 * 5;
